import { render, staticRenderFns } from "./CustomExtensionDeleteModal.vue?vue&type=template&id=fbd040b4&"
import script from "./CustomExtensionDeleteModal.vue?vue&type=script&lang=ts&"
export * from "./CustomExtensionDeleteModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports